module.exports = __webpack_public_path__ + "static/nxrt-automotive3-afadd6b0e109f7c4ffd72600e4684105.jpg";